import { makeActionCreator } from '../../../../utilities'
import { WoundCareConstants } from './woundCare.constants'

export const setActions = makeActionCreator(WoundCareConstants.SET_ACTIONS, 'actions')
export const setSite = makeActionCreator(WoundCareConstants.SET_SITE, 'site')
export const setSize = makeActionCreator(WoundCareConstants.SET_SIZE, 'size')
export const saveWoundCare = makeActionCreator(WoundCareConstants.SAVE_WOUND_CARE, 'data')
export const resetState = makeActionCreator(WoundCareConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(WoundCareConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(WoundCareConstants.SET_STATE, 'woundCareState')
export const setDateTime = makeActionCreator(WoundCareConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(WoundCareConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectWoundCareProcedure = makeActionCreator(WoundCareConstants.ON_SELECT_WOUND_CARE)
export const setUpdateInputRows = makeActionCreator(WoundCareConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(WoundCareConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(WoundCareConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(WoundCareConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
